import { useFormContext } from 'react-hook-form';
import { Grid } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import HelpIcon from '@material-ui/icons/Help';
import { AppTextfield } from '../input/AppTextfield';
import { AppDatePicker } from '../input/AppDatePicker';
import { AppCheckbox } from '../input/AppCheckbox';
import { emailValidation } from '../../../const/Const';
import { CustomTooltip } from '../../tooltip/CustomTooltip';
import { tooltipContents } from '../../tooltip/Const';

type TProps = {
  index: number;
  onChangeUploadable: () => void;
  deleteShareList?: () => void;
  fieldsCount?: number;
};

export const InputGuestField = (props: TProps) => {
  const { index, onChangeUploadable, deleteShareList, fieldsCount } = props;

  const {
    formState: { errors }
  } = useFormContext();

  return (
    <>
      {/* 左側 */}
      <Grid xs={7}>
        <div
          style={{
            margin: '10px 10px 0 10px ',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <div style={{ width: 120, marginRight: 44 }}>
            共有先<span style={{ color: 'red' }}>（必須）</span>
          </div>
          <AppTextfield
            name={`list.${index}.name`}
            style={{ width: 360 }}
            required={true}
            errorMessage={
              errors.list &&
              Array.isArray(errors.list) &&
              errors.list.length > index
                ? (errors.list[index]?.name?.message as string)
                : ''
            }
            label='コノック太郎　〇〇工務店'
            maxLength={100}
          />
        </div>

        <div style={{ margin: 10, display: 'flex', alignItems: 'center' }}>
          <div style={{ width: 120, marginRight: 4 }}>メールアドレス</div>
          <CustomTooltip
            title={tooltipContents.ShareEmail}
            placement='top'
            interactive
          >
            <HelpIcon color='action' style={{ marginRight: 16 }} />
          </CustomTooltip>
          <AppTextfield
            name={`list.${index}.email`}
            style={{ width: 360 }}
            label='conoc@example.com'
            errorMessage={
              errors.list &&
              Array.isArray(errors.list) &&
              errors.list.length > index
                ? (errors.list[index]?.email?.message as string)
                : ''
            }
            emailValidation={emailValidation}
            maxLength={50}
          />
        </div>
      </Grid>

      {/* 右側 */}
      <Grid xs={4}>
        <div
          style={{
            margin: 10,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'end'
          }}
        >
          <div style={{ marginRight: 4 }}>共有期限</div>
          <CustomTooltip
            title={tooltipContents.ShareExpirationDate}
            placement='top'
          >
            <HelpIcon color='action' style={{ marginRight: 16 }} />
          </CustomTooltip>
          <AppDatePicker
            name={`list.${index}.expiration_at`}
            style={{ width: 160 }}
            errorMessage={
              errors.list &&
              Array.isArray(errors.list) &&
              errors.list.length > index
                ? (errors.list[index]?.expiration_at?.message as string)
                : ''
            }
          />
        </div>

        <div
          style={{
            margin: 10,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'end'
          }}
        >
          <AppCheckbox
            name={`list.${index}.uploadable`}
            onChange={onChangeUploadable}
          />
          <div style={{ marginRight: 4 }}>アップロード可能</div>
          <CustomTooltip
            title={tooltipContents.ShareUploadable}
            placement='top-end'
            interactive
          >
            <HelpIcon color='action' />
          </CustomTooltip>
        </div>
      </Grid>

      {/* 共有先が２つ以上の場合に表示 */}
      {fieldsCount && fieldsCount > 1 && (
        <>
          {/* 削除アイコン */}
          <Grid xs={1}>
            <CloseIcon
              style={{ cursor: 'pointer' }}
              onClick={deleteShareList}
            />
          </Grid>

          {/* 下部の境界線 */}
          <Grid
            xs={12}
            style={{ borderBottom: '1px solid #e6e6e6', margin: '12px 0' }}
          ></Grid>
        </>
      )}
    </>
  );
};
